"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./lib/angular2-token.service'));
__export(require('./lib/angular2-token.model'));
__export(require('./lib/a2t-ui/a2t-ui.module'));



//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/angular2-token/angular2-token.js
// module id = ../../../../angular2-token/angular2-token.js
// module chunks = 3